import { Box } from '@mui/material';

import { CountIndicator } from '@work4all/components/lib/dataDisplay/count-indicator/CountIndicator';

import { User } from '@work4all/models/lib/Classes/User.entity';

import { useAppointmentsSummary } from '../hooks/use-appointments-summary';

export const IndicatorContainer = (props: { users: User[] }) => {
  const { users } = props;

  const appointments = useAppointmentsSummary({ users });

  return appointments.length > 0 ? (
    <Box paddingRight="1rem">
      <CountIndicator value={appointments.length} />
    </Box>
  ) : null;
};
